(function ($) {
  function initShareWidget() {
    $('[data-component="shareWidget"]').each(function () {
      const $widget = $(this);
      let isOpen = false;

      $widget.find('[data-component="share"]').on('click', function (event) {
        event.stopPropagation();

        const shareUrl = $(this).data('url');

        if (shareUrl) {
          if (shareUrl.startsWith('mailto:')) {
            window.location.href = shareUrl;
          } else {
            window.open(shareUrl, '_blank', 'width=600,height=400');
          }
        }
      });

      $widget.find('.share-toggle').on('click', function (event) {
        event.stopPropagation();

        if (isOpen) {
          $widget.removeClass('is-open');
          isOpen = false;
        } else {
          $widget.addClass('is-open');
          isOpen = true;
        }
      });

      $(document).on('click.shareWidget', function (event) {
        if (
          isOpen &&
          !$(event.target).closest('[data-component="shareWidget"]').length
        ) {
          $widget.removeClass('is-open');
          isOpen = false;
        }
      });
    });
  }

  $(document).ready(function () {
    initShareWidget();
  });
})(jQuery);
